import { consultaMovil } from './movil';

/**
 * Comparte un enlace: en movil y tableta con la hoja de compartir del sistema; si no, al
 * portapapeles. Por http en la red local no hay API del portapapeles (solo en https o localhost):
 * se prueba la copia de siempre y, si tampoco, se ensena el enlace para copiarlo a mano.
 * Devuelve el texto para el usuario.
 */
export async function compartirEnlace(url: string, titulo: string): Promise<string> {
  if (consultaMovil()?.matches && typeof navigator.share === 'function') {
    try {
      await navigator.share({ title: titulo, url });
      return 'Enlace compartido.';
    } catch (err) {
      if ((err as { name?: string }).name === 'AbortError') return 'No se ha compartido.';
    }
  }
  try {
    await navigator.clipboard.writeText(url);
    return 'Enlace copiado al portapapeles.';
  } catch { /* sin API del portapapeles */ }
  const t = document.createElement('textarea');
  t.value = url;
  t.setAttribute('readonly', '');
  t.style.cssText = 'position:fixed;top:0;left:0;opacity:0';
  document.body.append(t);
  t.select();
  let copiado = false;
  try { copiado = document.execCommand('copy'); } catch { /* sin copia */ }
  t.remove();
  if (copiado) return 'Enlace copiado al portapapeles.';
  window.prompt('Copia el enlace:', url);
  return 'Enlace listo para copiar.';
}
